import { fetchCognitoConfig } from 'libs/api'
import { resolveTenantId } from 'utils/tenant'
import { useAuthContext } from './useAuthContext'
import { useQuery } from './useQuery'

/**
 * The tenant the current subdomain belongs to.
 *
 * Prefers the signed-in user's own attribute and falls back to the subdomain's
 * Cognito config, which is already cached by CognitoConfigLoader and is the
 * only source available on unauthenticated pages.
 */
export function useTenantId(): string | null {
  const { currentAuthenticatedUser } = useAuthContext()
  const { data: cognitoConfig } = useQuery(fetchCognitoConfig)

  return (
    resolveTenantId(currentAuthenticatedUser?.attributes?.['custom:tenant_id']) ??
    resolveTenantId(cognitoConfig?.['tenant-id'])
  )
}
